"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedLogoVisibility = void 0;
var EmbedLogoVisibility;
(function (EmbedLogoVisibility) {
    EmbedLogoVisibility["CONTROL_BAR"] = "CONTROL_BAR";
    EmbedLogoVisibility["ALWAYS"] = "ALWAYS";
})(EmbedLogoVisibility = exports.EmbedLogoVisibility || (exports.EmbedLogoVisibility = {}));
//# sourceMappingURL=embed-logo-visibility.js.map